import setAuthToken from '../utils/setAuthToken';
import jwt_decode from 'jwt-decode';
import { GET_ERRORS, SET_CURRENT_USER } from './types';
import Cookies from 'js-cookie'
import axiox from './axios'

const domainRule = [
  "st.vhu.edu.vn",
  "hunghau.vn",
  "vhu.edu.vn"
]
// Register User
export const authenticated = (navigation,access_token) => dispatch => {
  Cookies.set("act",access_token)
  if(access_token){
    axiox.get("/api/users/login")
      .then( (resu) => {
        dispatch(setCurrentUser(resu.data))
        navigation.push('/dashboard')
      })
      .catch(err => console.log(err))
  }else{
    navigation.push('/login')
  }
}

// Set logged in user
export const setCurrentUser = decoded => {
  return {
    type: SET_CURRENT_USER,
    payload: decoded
  };
};

// Log user out
export const logoutUser = () => dispatch => {
  // Remove token from localStorage
  localStorage.removeItem('jwtToken');
  // Remove auth header for future requests
  setAuthToken(false);
  // Set current user to {} which will set isAuthenticated to false
  dispatch(setCurrentUser({}));
};



// WEBPACK FOOTER //
// ./src/actions/authActions.js